import { takeLatest } from 'redux-saga';
import { put, call, fork, select } from 'redux-saga/effects';
import { fromJS } from 'immutable';
var Scroll = require('react-scroll');
var scroll = Scroll.animateScroll;

import { fetchUser, createUserSettings, saveUserSettings, updateUserSettings } from '../../utils/jsonapi-functions/users';
import { getUserId } from '../../selectors/user-selectors';
import { getHasUserSettings, getSettingsId } from '../../selectors/user-settings-selectors';
import { reportError } from '../../utils/error-handling-service';
import { SET_STATUS_BAR } from '../../containers/status-bar/constants';
import { ALL, INSTANTLY } from '../../utils/static-configuration';
import {
  LOAD_SETTINGS,
  LOAD_SETTINGS_SUCCESS,
  LOAD_SETTINGS_ERROR,
  UPDATE_SETTINGS,
  UPDATE_SETTINGS_SUCCESS,
  UPDATE_SETTINGS_ERROR,
} from './constants';

export function* loadSettings(action) {
  try {
    const userId = yield select(getUserId);
    const userDetails = yield call(fetchUser, userId);
    const userDetailsJSON = userDetails.toJSONTree();

    const hasUserSettings = userDetailsJSON.settings ? true : false;
    const userSettings = hasUserSettings ? userDetailsJSON.settings : { emailType: ALL, emailFrequency: INSTANTLY };
    yield put({ type: LOAD_SETTINGS_SUCCESS, data: { settings: fromJS(userSettings), hasUserSettings } });
  } catch (error) {
    reportError('LOAD_SETTINGS_ERROR', error.message);
    yield put({ type: LOAD_SETTINGS_ERROR, error: error.message });
  }
}

export function* updateSettings(action) {
  try {
    const { data } = action;
    const userId = yield select(getUserId);
    const hasUserSettings = yield select(getHasUserSettings);

    if (hasUserSettings) {
      const settingsId = yield select(getSettingsId);
      yield call(updateUserSettings, settingsId, data);
    } else {
      const userSettings = yield call(createUserSettings, data);
      const updatedUser = yield call(saveUserSettings, userId, userSettings);
    }

    yield put({ type: UPDATE_SETTINGS_SUCCESS, data });
    yield put({ type: SET_STATUS_BAR, message: 'Settings updated successfully.', colour: 'green' });
    scroll.scrollToTop();

  } catch (error) {
    reportError('UPDATE_SETTINGS_ERROR', error.message);
    yield put({ type: SET_STATUS_BAR, message: 'Failed to update settings, please try again.', colour: 'red' });
    scroll.scrollToTop();
    yield put({ type: UPDATE_SETTINGS_ERROR, error: error.message });
  }
}

export function* watchLoadSettings() {
  yield takeLatest(LOAD_SETTINGS, loadSettings);
}

export function* watchUpdateSettings() {
  yield takeLatest(UPDATE_SETTINGS, updateSettings);
}

export default function* userSettingsSagas() {
  yield [fork(watchLoadSettings), fork(watchUpdateSettings)];
}



/** WEBPACK FOOTER **
 ** ./src/containers/user-settings/sagas.js
 **/